module.exports = __webpack_public_path__ + "img/footer_icon.57fd8e4c.png";